import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.css';
export default {
  props: {
    index: {},
    containerTemplateId: {
      type: Number,
      default: -1
    },
    containerTemplateInfo: {}
  },
  data() {
    return {
      hot: null,
      cellStyleObj: {},
      dataSource: [['', ''], ['', '']],
      disabledRows: [1]
    };
  },
  watch: {
    containerTemplateId(val) {
      if (val) {
        if (this.containerTemplateId !== -1) {
          this.editTable();
        } else {
          this.cellStyleObj = {};
          this.newTable();
        }
      }
    },
    containerTemplateInfo(val) {
      if (val) {
        if (this.containerTemplateId !== -1) {
          this.editTable();
        }
      }
    }
  },
  created() {
    const that = this;
    this.setting = {
      data: [['', ''], ['', '']],
      className: 'htCenter htMiddle',
      colWidths: 120,
      rowHeights: 40,
      height: 200,
      disableVisualSelection: true,
      colHeaders: false,
      cells: function (row, col, prop) {
        function cellStyleRenderer(instance, td, row, col, prop, value, cellProperties) {
          Handsontable.renderers.TextRenderer.apply(this, arguments);
          td.style.background = '#f1f1fe';
        }
        var cellProperties = {};
        let currentValue = row + ',' + col;
        if (that.disabledRows.indexOf(row) !== -1) {
          cellProperties.renderer = cellStyleRenderer; // uses function directly
        }
        if (that.cellStyleObj[currentValue] && that.cellStyleObj[currentValue].bgColorValue) {
          let color = that.cellStyleObj[currentValue].bgColorValue;
          function cellBgcolorRenderer(instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.background = color;
          }
          cellProperties.renderer = cellBgcolorRenderer;
        }
        cellProperties.readOnly = true;
        return cellProperties;
      }
    };
    console.log(this.containerTemplateId, 'this.containerTemplateId');
    if (this.containerTemplateId !== -1) {
      this.editTable();
    } else {
      // this.newTable();
      this.$nextTick(() => {
        this.hot = new Handsontable(this.$refs['tableControl' + this.index], this.setting);
      });
    }
  },
  mounted() {
    console.log(this.setting, 'setting');
    // this.hot = new Handsontable(this.$refs['tableControl' + this.index], this.setting);
  },
  methods: {
    newTable() {
      const that = this;
      this.setting = {
        data: [['', ''], ['', '']],
        className: 'htCenter htMiddle',
        colWidths: 120,
        rowHeights: 40,
        height: 200,
        disableVisualSelection: true,
        colHeaders: false,
        cells: function (row, col, prop) {
          function cellStyleRenderer(instance, td, row, col, prop, value, cellProperties) {
            Handsontable.renderers.TextRenderer.apply(this, arguments);
            td.style.background = '#f1f1fe';
          }
          var cellProperties = {};
          let currentValue = row + ',' + col;
          if (that.disabledRows.indexOf(row) !== -1) {
            cellProperties.renderer = cellStyleRenderer; // uses function directly
          }
          if (that.cellStyleObj[currentValue] && that.cellStyleObj[currentValue].bgColorValue) {
            let color = that.cellStyleObj[currentValue].bgColorValue;
            function cellBgcolorRenderer(instance, td, row, col, prop, value, cellProperties) {
              Handsontable.renderers.TextRenderer.apply(this, arguments);
              td.style.background = color;
            }
            cellProperties.renderer = cellBgcolorRenderer;
          }
          cellProperties.readOnly = true;
          return cellProperties;
        }
      };
      this.$nextTick(() => {
        this.hot = new Handsontable(this.$refs['tableControl' + this.index], this.setting);
      });
    },
    editTable() {
      this.disabledRows = [];
      let type = typeof this.containerTemplateInfo;
      let echoData = type === 'string' ? JSON.parse(this.containerTemplateInfo) : this.containerTemplateInfo;
      console.log(echoData, 'echoData');
      if (echoData && Object.keys(echoData).length > 0) {
        let rawData = JSON.parse(echoData.rawData);
        let rowsNumber = rawData.rowNumber;
        if (echoData.tableTail === 'NO') {
          rowsNumber = rowsNumber - 1;
        }
        if (echoData.tableHead === 'YES') {
          rowsNumber = rowsNumber - echoData.tableHeadNum;
        }
        console.log(rawData, rowsNumber, 'resdetail');
        for (let i = 0; i < rowsNumber; i++) {
          if (echoData.tableHead === 'NO' && i >= echoData.tableHeadNum || echoData.tableHead === 'YES') {
            this.disabledRows.push(i);
          }
        }
        // console.log(this.disabledRows, rawData.rowsNumber, 'this.disabledRows');
        this.cellStyleObj = JSON.parse(rawData.cellStyleObj);
        let mergeCells = JSON.parse(rawData.mergeCells);
        console.log(mergeCells, 'mergeCellscontrol');
        let data = JSON.parse(rawData.tableData);
        let mergeCellsArr = [];
        mergeCells.forEach(item => {
          let obj = {
            row: item.from.row,
            col: item.from.col,
            rowspan: item.to.row - item.from.row + 1,
            colspan: item.to.col - item.from.col + 1
          };
          mergeCellsArr.push(obj);
        });
        this.setting.data = data;
        this.setting.mergeCells = mergeCellsArr;
        console.log(this.setting, 'this.setting');
        this.$nextTick(() => {
          this.hot ? this.hot.updateSettings(this.setting) : new Handsontable(this.$refs['tableControl' + this.index], this.setting);
        });
      }
    }
  }
};